import { pageSwitch } from 'app/ConferenciaCampo/screens/Fazendas/pageSwitch';
import SolicitacaoRoute from 'app/TakeUp/SolicitacoesEdicao/components/SolicitacaoRoute';
import { SnackbarProvider } from 'notistack';
import React, { Suspense } from 'react';
import { AuthenticationState, AzureAD } from 'react-aad-msal';
import { Route, Switch } from 'react-router-dom';
import { URLS } from 'res/URLS';
import Loader from 'shared/Layout/components/Loader';
import Home from '../../app/Home/Home';
import LoginModule from '../../app/Login';
import Layout from '../../shared/Layout';
import { authProvider } from '../msal/authProvider';
import Path from './paths';
import PrivateRoute from './PrivateRoute';

const OrdensColheita = React.lazy(() => import('app/OrdensColheita/screens/OrdensColheita'));
const CadastroEquipes = React.lazy(() => import('app/CadastroEquipes/screens/CadastroEquipes'));
const CadastroLocaisArmazenamento = React.lazy(() =>
  import('app/CadastroLocaisArmazenamento/screens/CadastroLocaisArmazenamento'),
);
const CadastroOcupacoes = React.lazy(() =>
  import('app/CadastroOcupacoes/screens/CadastroOcupacoes'),
);
const CadastroMotivosParada = React.lazy(() =>
  import('app/CadastroMotivosParada/screens/CadastroMotivosParada'),
);
const CadastroVariedades = React.lazy(() =>
  import('app/CadastroVariedades/screens/CadastroVariedades'),
);
const CadastroAlgodoeira = React.lazy(() =>
  import('app/CadastroAlgodoeira/screens/Show'),
);
const CadastroProjecaoProducao = React.lazy(() =>
  import('app/CadastroProjecaoProducao/screens/Show'),
);
const CadastroFabricantesLonas = React.lazy(() =>
  import('app/CadastroFabricanteLonas/screens/Show'),
);
const CadastroSinistrosLonas = React.lazy(() =>
  import('app/CadastroSinistrosLonas/screens/Show'),
);
const CadastroAprovadoresInventario = React.lazy(() =>
  import('app/Inventario/CadastroAprovador/screens/Show'),
);
const CadastroInventarioRolosFardinhos = React.lazy(() =>
  import('app/CadastroInventarioRolosFardinhos/screens/Show'),
);
const CadastroPatiosLotes = React.lazy(() =>
  import('app/CadastroPatiosLotes/screens/Show'),
);

const CadastroProtocoloMalas = React.lazy(() => import('app/ProtocoloMalas/screens/Show'));
const CadastroFazendas = React.lazy(() => import('app/CadastroFazendas/screens/Show'));
const CadastroPerguntasPQAB = React.lazy(() => import('app/CadastroPerguntasPQAB/screens/Show'));
const CadastroLaboratorios = React.lazy(() => import('app/CadastroLaboratorios/screens/Show'));
const CadastroGrupoVariedade = React.lazy(() => import('app/CadastroGrupoVariedade/screens/Show'));
const CadastroInspetores = React.lazy(() => import('app/CadastroInspetores/screens/Show'));

const MenuCadastros = React.lazy(() => import('app/MenusFooter/screens/MenuCadastros'));
const MenuConfig = React.lazy(() => import('app/MenusFooter/screens/MenuConfiguracoes'));
const MenuIntegracoes = React.lazy(() => import('app/MenusFooter/screens/MenuIntregacoes'));
const ImportacaoHVI = React.lazy(() => import('app/Importacao/screens/ImportacaoHVI'));
const ImportacaoClassificacao = React.lazy(() => import('app/Importacao/screens/ImportacaoClassificacao'));

const ListagemRolosFardoes = React.lazy(() => import('app/RolosFardoes/ListagemRolosFardoes'));

const PainelIntegracaoSapPims = React.lazy(() => import('app/PainelIntegracaoSapPims/screens/Show'));
const PainelIntegracaoMalasHVI = React.lazy(() => import('app/PainelIntegracaoMalasHVI/screens/Show'));
const FilaIntegracaoIndex = React.lazy(() => import('app/FilaIntegracao/screens/Show'));
const AprovacaoInventarioIndex = React.lazy(() => import('app/AprovacaoInventario/screens/Show'));
const CadastroPadroesHVI = React.lazy(() => import('app/CadastroPadroesHVI/screens/Show'));
const CadastroVinculosLocaisEntrega = React.lazy(() => import('app/CadastroVinculosLocaisEntrega/screens/Show'));
const CadastroRegioesFazendas = React.lazy(() => import('app/RegioesFazendas/screens/Show'));
const PermissoesIndex = React.lazy(() => import('app/Permissoes/screens/Show'));
const ParametroAlgodoeiraIndex = React.lazy(() => import('app/ParametrosAlgodoeira/screens/ParametrosAlgodoeira'));
const LeituraView = React.lazy(() => import('app/Carga/screens/LeituraView'));
const ParametrosIntegracao = React.lazy(() => import('app/CadastroIntegracao/screens/Show'));
const CadastroCaracteristicasLotes = React.lazy(() => import('app/CadastroCaracteristicasLotes/screens/Show'));
const FardinhosNaoCategorizados = React.lazy(() => import('app/FardinhosNaoCategorizados/screens/Show'));
const LotsList = React.lazy(() => import('app/Lots/screens/List'));
const LotShow = React.lazy(() => import('app/Lots/screens/Show'));
const CadastroTransportador = React.lazy(() =>
  import('app/CadastroTransportador/screens/CadastroTransportador'),
);

const PortalBalancaIndex = React.lazy(() => import('app/PortalBalanca/screens/Show'));

const ConferenciaPatioIndex = React.lazy(() => import('app/ConferenciaPatio/screens/Show'));

const SessoesIndex = React.lazy(() => import('app/Sessoes/screens/Show'));

const MenuRelatorios = React.lazy(() => import('app/MenusFooter/screens/MenuRelatorios'));

const DetalhesSessao = React.lazy(() => import('app/Sessoes/screens/Details'));

const SelecionarSessaoDestino = React.lazy(() =>
  import('app/Sessoes/screens/SelecionarSessaoDestino'),
);

const MovimentarSessao = React.lazy(() => import('app/Sessoes/screens/MovimentarSessao'));

const ExcluirRolosSessao = React.lazy(() => import('app/Sessoes/screens/ExcluirRolos'));

const DetalhesConferenciaCampo = React.lazy(() => import('app/ConferenciaCampo/screens/Detalhes'));

const RelatorioPadroesHVI = React.lazy(() => import('app/PadroesHVI/screens/Show'));

const Comercial = React.lazy(() => import('app/Comercial/screens/ListaGrupoCliente'));

const DetalhesGrupoCliente = React.lazy(() => import('app/Comercial/screens/DetalhesGrupoCliente'));

const ImportacaoActs = React.lazy(() => import('app/ImportacaoActs/screens/Show'));

const EstoqueRelatorio = React.lazy(() => import('app/Estoque/screens/EstoqueRelatorio'));

const EstoqueComercial = React.lazy(() => import('app/Estoque/screens/EstoqueComercial'));

const EmailsBeneficiamentoDiario = React.lazy(() => import('app/EmailsBeneficiamentoDiario/screens/Show'));

const ConfiguracaoEnvioEmails = React.lazy(() => import('app/ConfiguracaoEnvioEmails/screens/Show'));

const EmailsCategorizacaoLotes = React.lazy(() => import('app/EmailsCategorizacaoLotes/screens/Show'));

const EmailsEnlonamentoRolos = React.lazy(() => import('app/EmailsEnlonamentoRolos/screens/Show'));

const DivergenciaSessoes = React.lazy(() => import('app/DivergenciaSessoes/screens/Show'));

const CargaEmAndamento = React.lazy(() => import('app/Carga/components/CargaEmAndamento'));

const ListagemCarregamentos = React.lazy(() => import('app/Carregamento/screen/ListagemCarregamentos'));

const FardinhosNoPorto = React.lazy(() => import('app/Comercial/components/Carregamento/FardinhosNoPorto/screen'));

const BeneficiamentoIndex = React.lazy(() => import('app/Beneficiamento/screens/Show'));

const FardinhosNaoClassificados = React.lazy(() => import('app/DashboardFardinhos/screens/Show'));

const ConferenciaEntradaProducao = React.lazy(() => import('app/EntradaProducao/screens/Show'));

const ConferenciaBlocos = React.lazy(() => import('app/ConferenciaBlocos/screens/Show'));

const ConferenciaPatioBeneficiados = React.lazy(() => import('app/ConferenciaPatioBeneficiados/screens/Show'));

const ConferenciaSessao = React.lazy(() => import('app/ConferenciaSessao/screens/Show'));

const ConferenciaRolos = React.lazy(() => import('app/ConferenciaRolos/screens/Show'));

const VolumeEstoque = React.lazy(() => import('app/VolumeEstoque/screens/Show'));

const SolicitacoesEstorno = React.lazy(() => import('app/Comercial/components/SolicitacoesEstorno'));

const SinistrosLonas = React.lazy(() => import('app/SinistrosLonas/screens/Show'));

const RelatorioMetas = React.lazy(() => import('app/RelatorioMetas/screens/Show'));

const InstrucoesSaldoCarregar = React.lazy(() => import('app/RelatorioInstrucoesSaldoCarregar/screens/Show'));

const SaldoInstruir = React.lazy(() => import('app/RelatorioSaldoInstruir/screens/Show'));

const ProducaoCategoria = React.lazy(() => import('app/ProducaoCategoria/screens/Show'));

const RelatorioProdutividade = React.lazy(() => import('app/RelatorioProdutividade/screens/Show'));

const AcompanhamentoEnlonamentoCampo = React.lazy(() => import('app/AcompanhamentoEnlonamentoCampo/screens/Show'));

const ImportacaoLotesTerceiros = React.lazy(() => import('app/ImportacaoLotesTerceiros/screens/Show'));

const ClassificacaoFardinhos = React.lazy(() => import('app/ClassificacaoFardinhos/screens/Show'));

const ConferenciaEnderecamentoFardos = React.lazy(() => import('app/ConferenciaEnderecamentoFardos/screens/Show'));

const TransferenciaLotes = React.lazy(() => import('app/TransferenciaLotes/screens/Show'));

const AcompanhamentoInstrucoesEmbarque = React.lazy(() => import('app/AcompanhamentoInstrucoesEmbarque/screens/Show'));

const PainelControleGerencial = React.lazy(() => import('app/PainelControleGerencial/screens/Show'));

const LaudosCertificados = React.lazy(() => import('app/LaudosCertificados/screens/Show'));

export default function App() {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState }) => {
        switch (authenticationState) {
          case AuthenticationState.Unauthenticated:
            return <Route exact path="/" component={LoginModule} />;
          case AuthenticationState.Authenticated:
            return (
              <SnackbarProvider
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                maxSnack={3}
                autoHideDuration={8000}
              >
                <Layout>
                  <Suspense fallback={<Loader />}>
                    <Switch>
                      <Route exact path="/" component={Home} />
                      <PrivateRoute
                        path="/rolos-fardos"
                        component={ListagemRolosFardoes}
                        permissionRequired="rolos-fardos.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.SESSOES}
                        component={SessoesIndex}
                        exact
                        permissionRequired="sessao.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.SESSAO_DETALHES}
                        exact
                        component={DetalhesSessao}
                        permissionRequired="sessao.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.SESSAO_MOVIMENTAR}
                        exact
                        component={MovimentarSessao}
                        permissionRequired="sessao.movimentar"
                      />
                      <PrivateRoute
                        path={Path.EXCLUIR_SESSAO_ROLOS}
                        exact
                        component={ExcluirRolosSessao}
                        permissionRequired="sessao.excluir-rolos"
                      />
                      <PrivateRoute
                        path={URLS.SESSAO_MOVIMENTAR_SESSAO}
                        exact
                        component={SelecionarSessaoDestino}
                        permissionRequired="sessao.movimentar"
                      />

                      <PrivateRoute
                        path={URLS.PERMISSOES}
                        component={PermissoesIndex}
                        permissionRequired="usuario.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.PARAMETROS_ALGODOEIRA}
                        component={ParametroAlgodoeiraIndex}
                        permissionRequired="configuracoes-maquinas.web.visualizar"
                      />
                      <PrivateRoute
                        path="/lotes"
                        component={LotsList}
                        permissionRequired="lote.web.visualizar"
                      />
                      <PrivateRoute
                        path="/lote/:id"
                        component={LotShow}
                        permissionRequired="lote.web.visualizar-detalhes"
                      />
                      <PrivateRoute
                        exact
                        path={URLS.TRANSFERENCIA_LOTES}
                        component={TransferenciaLotes}
                        permissionRequired="transferencia-lotes.web.visualizar"
                      />
                      <PrivateRoute
                        exact
                        path={URLS.MENU_PAINEL_INTEGRACOES}
                        component={MenuIntegracoes}
                        permissionRequired="painel-integracao.web.visualizar"
                      />
                      <PrivateRoute
                        exact
                        path={URLS.PAINEL_INTEGRACAO_SAP_PIMS}
                        component={PainelIntegracaoSapPims}
                        permissionRequired="painel-integracao.web.sap-pims.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.PAINEL_INTEGRACAO_ABRAPA}
                        component={PainelIntegracaoMalasHVI}
                        permissionRequired="painel-integracao.web.malas-hvi.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.FILA_INTEGRACAO}
                        component={FilaIntegracaoIndex}
                        permissionRequired="painel-integracao.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.INVENTARIOS_APROVACAO}
                        component={AprovacaoInventarioIndex}
                        permissionRequired={["inventario.web.visualizar", "inventario.web.aprovar-recusar"]}
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_PADROES_HVI}
                        component={CadastroPadroesHVI}
                        permissionRequired="parametro-padrao-hvi.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_VINCULOS_LOCAIS_ENTREGA}
                        component={CadastroVinculosLocaisEntrega}
                        permissionRequired="parametro-padrao-hvi.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_REGIOES_FAZENDAS}
                        component={CadastroRegioesFazendas}
                        permissionRequired="regioes.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.ORDENS_COLHEITA}
                        component={OrdensColheita}
                        permissionRequired="transportador.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_EQUIPES}
                        component={CadastroEquipes}
                        permissionRequired="equipes.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_LOCAIS_ARMAZENAMENTO}
                        component={CadastroLocaisArmazenamento}
                        permissionRequired="configuracoes-maquinas.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_VARIEDADES}
                        component={CadastroVariedades}
                        permissionRequired="cadastro-basico.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_OCUPACOES}
                        component={CadastroOcupacoes}
                        permissionRequired="cadastro-basico.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_PROJECAO_PRODUCAO}
                        component={CadastroProjecaoProducao}
                        permissionRequired="projecao-fazenda.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_FABRICANTES_LONAS}
                        component={CadastroFabricantesLonas}
                        permissionRequired="fabricante-lonas.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_SINISTROS_LONAS}
                        component={CadastroSinistrosLonas}
                        permissionRequired="fabricante-lonas.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_APROVADORES_INVENTARIO}
                        component={CadastroAprovadoresInventario}
                        permissionRequired="aprovador-inventario.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_INVENTARIO_ROLOS_FARDINHOS}
                        component={CadastroInventarioRolosFardinhos}
                        permissionRequired="inventario.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_PATIOS_LOTES}
                        component={CadastroPatiosLotes}
                        permissionRequired="patio-lotes.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_ALGODOEIRA}
                        component={CadastroAlgodoeira}
                        permissionRequired="projecao-fazenda.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_PROTOCOLO_MALAS}
                        component={CadastroProtocoloMalas}
                        permissionRequired="mala.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_FAZENDAS}
                        component={CadastroFazendas}
                        permissionRequired="fazenda.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_PERGUNTAS_PQAB}
                        component={CadastroPerguntasPQAB}
                        permissionRequired="fazenda.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_LABORATORIOS}
                        component={CadastroLaboratorios}
                        permissionRequired="laboratorio.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_INSPETORES}
                        component={CadastroInspetores}
                        permissionRequired="laboratorio.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_GRUPO_VARIEDADE}
                        component={CadastroGrupoVariedade}
                        permissionRequired="laboratorio.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_INSPETORES}
                        component={CadastroInspetores}
                        permissionRequired="laboratorio.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_MOTIVOS_PARADAS}
                        component={CadastroMotivosParada}
                        permissionRequired="motivo-parada.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.MENU_CADASTROS}
                        component={MenuCadastros}
                        permissionRequired={[
                          "motivo-parada.web.visualizar",
                          "transportador.web.visualizar",
                          "projecao-fazenda.web.visualizar",
                          "fabricante-lonas.web.visualizar",
                        ]}
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_CARACTERISTICAS_LOTES}
                        component={CadastroCaracteristicasLotes}
                        permissionRequired="lote-caracteristica-categoria.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.FARDINHOS_NAO_CATEGORIZADOS}
                        component={FardinhosNaoCategorizados}
                        permissionRequired="relatorios.dashboard.classificacao-algodao"
                      />
                      <PrivateRoute
                        path={URLS.CADASTRO_PARAMETROS}
                        component={ParametrosIntegracao}
                        permissionRequired="parametro-integracao.web.visualizar"
                      />
                      <PrivateRoute
                        path={URLS.MENU_CONFIGURACOES}
                        component={MenuConfig}
                        permissionRequired={[
                          "parametro-integracao.web.visualizar",
                          "configuracoes-maquinas.web.visualizar",
                          "email-beneficiamento-diario.web.visualizar",
                          "email-informativo-bloco-formado.web.visualizar",
                          "email-informativo-enlonamento.web.visualizar",
                        ]}
                      />
                      <PrivateRoute
                        path={URLS.IMPORTACAO_HVI}
                        component={ImportacaoHVI}
                        permissionRequired="importacao.web.hvi"
                      />
                      <PrivateRoute
                        path={URLS.IMPORTACAO_CLASSIFICACAO}
                        component={ImportacaoClassificacao}
                        permissionRequired="importacao.web.classificacao-visual"
                      />

                      <PrivateRoute
                        exact
                        path={URLS.LEITURA}
                        component={LeituraView}
                        permissionRequired="carga.web.leitura-tempo-real"
                      />

                      <PrivateRoute
                        path={URLS.CADASTRO_TRANSPORTADOR}
                        component={CadastroTransportador}
                        permissionRequired="transportador.web.visualizar"
                      />

                      <PrivateRoute
                        exact
                        path={URLS.CARGAS}
                        component={PortalBalancaIndex}
                        permissionRequired="carga.web.visualizar"
                      />

                      <PrivateRoute
                        exact
                        path={URLS.SOLICITACAO_EDICAO}
                        component={SolicitacaoRoute}
                        permissionRequired="comercial.take-up.solicitacoes-edicao.visualizar"
                      />

                      <PrivateRoute
                        exact
                        path={URLS.SOLICITACAO_ESTORNO_CARREGAMENTOS}
                        component={SolicitacoesEstorno}
                        permissionRequired="carregamentos.estorno.aprovar-recusar"
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.conferencia-do-patio"
                        path={URLS.CONFERENCIA_PATIO}
                        component={ConferenciaPatioIndex}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.detalhes_beneficiamento"
                        path={URLS.BENEFICIAMENTO}
                        component={BeneficiamentoIndex}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.dashboard.classificacao-algodao"
                        path={URLS.FARDINHOS_NAO_CLASSIFICADOS}
                        component={FardinhosNaoClassificados}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.entrada-producao"
                        path={URLS.ENTRADA_PRODUCAO}
                        component={ConferenciaEntradaProducao}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.conferencia-bloco"
                        path={URLS.CONFERENCIA_BLOCOS}
                        component={ConferenciaBlocos}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.conferencia-patio"
                        path={URLS.CONFERENCIA_PATIO_BENEFICIADOS}
                        component={ConferenciaPatioBeneficiados}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.conferencia-sessao"
                        path={URLS.CONFERENCIA_SESSAO}
                        component={ConferenciaSessao}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.conferencia-rolos"
                        path={URLS.CONFERENCIA_ROLOS}
                        component={ConferenciaRolos}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.VOLUME_ESTOQUE}
                        component={VolumeEstoque}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.sinistros-em-lonas"
                        path={URLS.SINISTROS_LONAS}
                        component={SinistrosLonas}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.metas.visualizar"
                        path={URLS.RELATORIO_METAS}
                        component={RelatorioMetas}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.RELATORIO_INSTRUCOES_SALDO_CARREGAR}
                        component={InstrucoesSaldoCarregar}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.RELATORIO_SALDO_INSTRUIR}
                        component={SaldoInstruir}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.RELATORIO_PRODUCAO_CATEGORIA}
                        component={ProducaoCategoria}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.RELATORIO_PRODUTIVIDADE}
                        component={RelatorioProdutividade}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.RELATORIO_ACOMPANHAMENTO_ENLONAMENTO_CAMPO}
                        component={AcompanhamentoEnlonamentoCampo}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.IMPORTACAO_LOTES_TERCEIROS}
                        component={ImportacaoLotesTerceiros}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.CLASSIFICACAO_FARDINHOS}
                        component={ClassificacaoFardinhos}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.volume-estoque-volume-embarcado"
                        path={URLS.FARDINHOS_NAO_CATEGORIZADOS}
                        component={FardinhosNaoCategorizados}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.conferencia-do-campo"
                        path={URLS.RELATORIO_ENDERECAMENTO_FARDOS}
                        component={ConferenciaEnderecamentoFardos}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.painel-de-gestao-operacional.painel"
                        path={URLS.PAINEL_CONTROLE_GERENCIAL}
                        component={PainelControleGerencial}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="relatorios.conferencia-do-campo"
                        path={URLS.ACOMPANHAMENTO_INSTRUCOES_EMBARQUE}
                        component={AcompanhamentoInstrucoesEmbarque}
                      />

                      <PrivateRoute
                        exact
                        permissionRequired="comercial.laudos.visualizar"
                        path={URLS.RELATORIO_LAUDOS_CERTIFICADOS}
                        component={LaudosCertificados}
                      />

                      <PrivateRoute
                        path={URLS.MENU_RELATORIOS}
                        component={MenuRelatorios}
                        permissionRequired={[
                          'relatorios.conferencia-do-patio',
                          'relatorios.comparativo-maquinas',
                          'relatorios.conferencia-campo',
                          'relatorios.padroes-de-hvi',
                          'relatorios.estoque',
                          'relatorios.dashboard.classificacao-algodao',
                        ]}
                      />
                      <PrivateRoute
                        path={Path.CONFERENCIA_CAMPO}
                        exact
                        component={pageSwitch}
                        permissionRequired="relatorios.conferencia-do-campo"
                      />

                      <PrivateRoute
                        path={Path.CONFERENCIA_CAMPO_DETALHES}
                        exact
                        component={DetalhesConferenciaCampo}
                        permissionRequired="relatorios.conferencia-do-campo"
                      />

                      <PrivateRoute
                        path={Path.RELATORIO_PADROES_HVI}
                        exact
                        component={RelatorioPadroesHVI}
                        permissionRequired="relatorios.padroes-de-hvi"
                      />

                      <PrivateRoute
                        path={Path.COMERCIAL}
                        exact
                        component={Comercial}
                        permissionRequired="comercial.listagem"
                      />

                      <PrivateRoute
                        path={Path.COMERCIAL_DETALHES_CONTRATO}
                        exact
                        component={DetalhesGrupoCliente}
                        permissionRequired="comercial.detalhes"
                      />

                      <PrivateRoute
                        path={Path.IMPORTACAO_ACTS}
                        component={ImportacaoActs}
                        permissionRequired="importacao.web.codigo-acts"
                      />

                      <PrivateRoute
                        path={Path.ESTOQUE_RELATORIO}
                        component={EstoqueRelatorio}
                        permissionRequired="relatorios.estoque"
                      />

                      <PrivateRoute
                        path={Path.ESTOQUE_COMERCIAL}
                        component={EstoqueComercial}
                        permissionRequired="comercial.visualizar-estoque"
                      />

                      <PrivateRoute
                        path={Path.CONFIGURACAO_ENVIO_EMAILS}
                        component={ConfiguracaoEnvioEmails}
                        permissionRequired={[
                          "email-informativo-bloco-formado.web.visualizar",
                          "email-beneficiamento-diario.web.visualizar",
                          "email-informativo-enlonamento.web.visualizar",
                        ]}
                      />

                      <PrivateRoute
                        path={Path.EMAILS_CATEGORIZACAO_LOTES}
                        component={EmailsCategorizacaoLotes}
                        permissionRequired="email-informativo-bloco-formado.web.visualizar"
                      />

                      <PrivateRoute
                        path={Path.EMAILS_BENEFICIAMENTO_DIARIO}
                        component={EmailsBeneficiamentoDiario}
                        permissionRequired="email-beneficiamento-diario.web.visualizar"
                      />

                      <PrivateRoute
                        path={Path.EMAILS_ENLONAMETO_ROLOS}
                        component={EmailsEnlonamentoRolos}
                        permissionRequired="email-informativo-enlonamento.web.visualizar"
                      />

                      <PrivateRoute
                        path={Path.DIVERGENCIA_SESSOES}
                        component={DivergenciaSessoes}
                        permissionRequired="whatsapp-divergencia-sessao.web.visualizar"
                      />

                      <PrivateRoute
                        path={Path.CARGA_EM_ANDAMENTO}
                        component={CargaEmAndamento}
                        permissionRequired="carga.web.visualizar"
                      />

                      <PrivateRoute
                        path={URLS.CARREGAMENTOS}
                        component={ListagemCarregamentos}
                        permissionRequired="carregamentos.listagem"
                      />

                      <PrivateRoute
                        path={Path.FARDINHOS_NO_PORTO}
                        component={FardinhosNoPorto}
                        permissionRequired="carregamentos.listagem"
                      />
                    </Switch>
                  </Suspense>
                </Layout>
              </SnackbarProvider>
            );
          case AuthenticationState.InProgress:
            return <Loader />;
          default:
        }
      }}
    </AzureAD>
  );
}
